import axios from "../../utils/axios"


// 分享逍客订单管理
export function getList(query) {
    return axios({
        url: "hfFxxkOrder/getList",
        method: "get",
        params: query
    });
}

export function synchronization() {
    return axios({
        url: "hfFxxkOrder/xk",
        method: "get"
    });
}




